import { render, staticRenderFns } from "./multi-patient.vue?vue&type=template&id=87b71542&scoped=true"
import script from "./multi-patient.vue?vue&type=script&lang=js"
export * from "./multi-patient.vue?vue&type=script&lang=js"
import style0 from "./multi-patient.vue?vue&type=style&index=0&id=87b71542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b71542",
  null
  
)

export default component.exports